export default __webpack_public_path__ + "3bd1a3adbfb6d1bbf2dd31297106be74.png";